import type { TFunction } from "i18next";
import z from "zod";
import type { Operator, Tariff } from "@/types/Operator";

export const getStep2Schema = (t: TFunction) =>
  z.object({
    operator: z
      .custom<Operator>()
      .optional()
      .nullable()
      .refine((val): val is Operator => Boolean(val) && Boolean(val?.id), {
        message: t("step2.validation.operator"),
      }),

    tariff: z
      .custom<Tariff>()
      .optional()
      .nullable()
      .refine((val): val is Tariff => Boolean(val) && Boolean(val?.id), {
        message: t("step2.validation.tariff"),
      }),
  });

export type Step2Schema = z.infer<ReturnType<typeof getStep2Schema>>;
